var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"controls":"","width":"100%","height":"auto","preload":"metadata","autoplay":_vm.autoplay}},[_c('source',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }